import Icon from '@plone/volto/components/theme/Icon/Icon';
import { injectIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import iconKwai from '../../icons/kwai.svg';

const SocialLinks = ({
  intl,
  'brand-colors': brandColors,
  label,
  labelClassName,
}) => {
  const networks = useSelector(
    (state) => state.site_properties.data?.social_networks?.items,
  );

  const settings = {
    Flickr: {
      icon: 'fa-brands fa-flickr',
      color: '#0063DC',
      textColor: '#fff',
    },
    Facebook: {
      icon: 'fa-brands fa-facebook-f',
      color: '#4267B2',
      textColor: '#fff',
    },
    Youtube: {
      icon: 'fa-brands fa-youtube',
      color: '#FF0000',
      textColor: '#fff',
    },
    Twitter: {
      icon: 'fa-brands fa-x-twitter',
      color: '#1DA1F2',
      textColor: '#fff',
    },
    Instagram: {
      icon: 'fa-brands fa-instagram',
      color: '#C13584',
      textColor: '#fff',
    },
    Kwai: {
      icon: iconKwai,
      iconType: 'img',
      color: '#EE802F',
      textColor: '#fff',
    },
    Linkedin: {
      icon: 'fa-brands fa-linkedin-in',
      color: '#0a66c2',
      textColor: '#fff',
    },
    RSS: {
      icon: 'fa-solid fa-rss',
      color: '#EE802F',
      textColor: '#fff',
    },
    Slideshare: {
      icon: 'fa-brands fa-slideshare',
      color: '#EE802F',
      textColor: '#fff',
    },
    Soundcloud: {
      icon: 'fa-brands fa-soundcloud',
      color: '#EE802F',
      textColor: '#fff',
    },
    Thumblr: {
      icon: 'fa-brands fa-tumblr',
      color: '#EE802F',
      textColor: '#fff',
    },
    TikTok: {
      icon: 'fa-brands fa-tiktok',
      color: '#000000',
      textColor: '#fff',
    },
    WhatsAppChannel: {
      icon: 'fa-brands fa-whatsapp',
      color: '#25D366',
      textColor: '#fff',
    },
    WhatsAppLink: {
      icon: 'fa-brands fa-whatsapp',
      color: '#25D366',
      textColor: '#fff',
    },
    WhatsAppTelephone: {
      icon: 'fa-brands fa-whatsapp',
      color: '#25D366',
      textColor: '#fff',
    },
  };

  if (networks && networks.length > 0) {
    const networksList = networks.map((network) => {
      const name = network.social_network;
      if (!name) {
        return null;
      }
      return (
        <a
          className={`br-button circle small${brandColors ? ' mr-base' : ''}`}
          style={
            brandColors
              ? {
                  backgroundColor: settings[name].color,
                  color: settings[name].textColor,
                }
              : null
          }
          href={network.social_network_url}
          key={network['@id']}
          title={name}
          aria-label={name}
        >
          {settings[name].iconType === 'img' ? (
            <Icon name={settings[name].icon} />
          ) : (
            <i className={settings[name].icon} aria-hidden="true" />
          )}
        </a>
      );
    });

    return (
      <>
        <div className={labelClassName}>{label}</div>
        {networksList}
      </>
    );
  } else {
    return null;
  }
};

export default injectIntl(SocialLinks);
